// src/components/common/intercom/IntercomHider.js
import { useEffect } from 'react';

const IntercomHider = () => {
  useEffect(() => {
    // Crear un elemento de estilo para ocultar el launcher predeterminado
    // y añadir estilos para el botón personalizado
    const style = document.createElement('style');
    style.innerHTML = `
      .intercom-lightweight-app, 
      #intercom-container .intercom-launcher-frame, 
      #intercom-container .intercom-launcher {
        display: none !important;
        opacity: 0 !important;
        pointer-events: none !important;
      }
      
      /* Estilos para nuestro botón de cierre personalizado */
      #custom-intercom-close-btn {
        transition: all 0.2s ease;
      }
      
      #custom-intercom-close-btn:hover {
        background-color: rgba(0, 0, 0, 0.7);
        transform: scale(1.05);
      }
      
      /* Media queries para ajustar la posición en diferentes tamaños de pantalla */
      @media (max-width: 768px) {
        #custom-intercom-close-btn {
          top: 15px;
          right: 15px;
          width: 28px;
          height: 28px;
          font-size: 14px;
        }
      }
    `;
    
    // Añadir al head del documento
    document.head.appendChild(style);
    
    // Limpiar al desmontar
    return () => {
      document.head.removeChild(style);
    };
  }, []);
  
  return null;
};

export default IntercomHider;